import React, { Component } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core/";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import _ from "lodash";
import { Card, CardBody, Button, Label } from "reactstrap";
import Fade from "react-reveal/Fade";
import Loader from "../../../Global/Loader";
import Table from "../../Components/Table";
import axios from "axios";
import { Services } from "../Services";
import { Icon, TextArea } from "semantic-ui-react";
import { Autocomplete, TextField } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";
import enLocale from "date-fns/locale/en-US";
import { DatePicker } from "@mui/x-date-pickers";
import CustomPopupIcon from "./customPopupIcon";
import { message } from "antd";
import Swal from "sweetalert2";
import moment from "moment";
import { withRouter } from "react-router-dom";
import createModal from "../../Components/ModalV2";
import Template from "./../template";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import Proveedor from "./../components/Proveedor";
import Consignatario from "./../components/Consignatario";
import { openNotification } from "../../Components/Notification";
import "./styles/styles.scss";
import { withNamespaces } from "react-i18next";

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e",
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

class createPedido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalError: false,
      errorMessage: "",
      modalSuccess: false,
      data: {},
      tableEntityConf: [
        { label: "ID", key: "EntityId" },
        { label: this.props.t("organization_name"), key: "Name" },
        { label: this.props.t("organization_code"), key: "Code" },
        { label: this.props.t("phone"), key: "Telephone" },
        { label: this.props.t("country"), key: "Country" },
      ],
      fieldsDependency: [
        ["GrossWeight", "UOMWeight"],
        ["Length", "Height", "Width", "UOMDimensions"],
      ],
      TemplateForms: _.cloneDeep(Template),
      createFormsData: [],
      isEdit: false,
      createForms: [],
      generalInfo: "",
      info: {},
      unEditedInfo: {},
      selectCatalog: [],
      camposUsuario: true,
      guardarDisabled: true,
      confirmPassError: false,
      loadingInfo: true,
      loadingTmpInfo: false,
      isEditing: false,
      tablaClientes: "",
      errors: [],
      pickupAddressInput: true,
      deliverAddressInput: true,
      infoValid: false,
      dateOpen: [],
      messageError: "",
    };
  }

  componentDidMount = async () => {
    // this.getRoles();
    // this.getUser();
    await this.getCatalogs();
    this.setState({ loadingInfo: false }, () => {
      this.renderForm(false);
    });
  };
  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        // this.getRoles();
        // this.getUser();
      }
    );
  };

  handleChangeDrop = (attribute, isEdit) => (evt, data) => {
    let {
      TemplateForms,
      info,
      pickupAddressInput,
      deliverAddressInput,
      selectCatalog,
      fieldsDependency,
    } = this.state;
    let campo = data ? data.value : null;
    info[attribute] = campo;
    if (campo !== null) {
      if (attribute == "FreightTermCode") {
        let [recoleccionCode, entregaCode] = data.value.split("2");
        let labelRecoleccion = recoleccionCode == "D";
        let labelEntrega = entregaCode == "D";
        TemplateForms[2][isEdit ? "edit" : "create"].map((campo) => {
          if (["SpecialInstructions", "PickupGoods"].indexOf(campo.id) >= 0) {
            campo.type =
              (campo.id == "PickupGoods" && labelRecoleccion) ||
                (campo.id == "SpecialInstructions" && labelEntrega)
                ? "LabelRef"
                : "Input";
          }
        });
        info["PickupGoods"] = labelRecoleccion ? info["PickupAddress"] : "";
        info["SpecialInstructions"] = labelEntrega
          ? info["DeliveryAddress"]
          : "";
        pickupAddressInput = !labelRecoleccion;
        deliverAddressInput = !labelEntrega;
      } else if (attribute == "TransportModeId") {
        info["FreightTermCode"] = "";
        this.setState({ loadingTmpInfo: true }, () => {
          axios
            .get(`${Services.ORDEN_SERV.path}orden/freightterms/${campo}`, {})
            .then((response) => {
              selectCatalog["FreightTerms"] = this.sortCatalogs(
                response.data.tramoContratado,
                "text"
              );
              this.setState(
                {
                  selectCatalog,
                  loadingTmpInfo: false,
                  pickupAddressInput: false,
                  deliverAddressInput: false,
                  info,
                },
                () => {
                  this.renderForm(isEdit);
                }
              );
            })
            .catch((error) => {
              console.warn(error);
            });
        });
      } else if (attribute == "CustomerId") {
        info["ConsigneeId"] = "";
        info["SupplierId"] = "";
        info["DeliveryAddress"] = "";
        info["PickupAddress"] = "";

        info["ConsigneeContacId"] = "";
        info["SupplierContactId"] = "";
        info["CheckDeliveryAddress"] = false;
        info["CheckPickupAddress"] = false;

        let limpiarRecoleccion = true;
        let limpiarEntrega = true;
        if (info["FreightTermCode"]) {
          let [recoleccionCode, entregaCode] =
            info["FreightTermCode"].split("2");
          limpiarRecoleccion = recoleccionCode == "D";
          limpiarEntrega = entregaCode == "D";
        }
        info["SpecialInstructions"] = limpiarRecoleccion
          ? ""
          : info["SpecialInstructions"];
        info["PickupGoods"] = limpiarEntrega ? "" : info["PickupGoods"];

        if (campo && campo != "") {
          let epCode = "";
          selectCatalog["Entities"].map((ent) => {
            if (ent.value == campo) {
              epCode = ent.data.CodeEP;
            }
          });
          this.setState({ loadingTmpInfo: true }, () => {
            axios
              .get(
                `${Services.ORDEN_SERV.path}orden/accountsByCustomer/${epCode}`,
                {}
              )
              .then((response) => {
                selectCatalog["consignees"] = this.sortCatalogs(
                  response.data.data.Consignees,
                  "entityName"
                );
                selectCatalog["suppliers"] = this.sortCatalogs(
                  response.data.data.Suppliers,
                  "entityName"
                );
                this.setState(
                  {
                    selectCatalog,
                    loadingTmpInfo: false,
                    info,
                  },
                  () => {
                    this.renderForm(isEdit);
                  }
                );
              })
              .catch((error) => {
                console.warn(error);
              });
          });
        }
      }
    } else {
      if (attribute == "TransportModeId") {
        info["FreightTermCode"] = null;
        selectCatalog["FreightTerms"] = [];
        TemplateForms[2][isEdit ? "edit" : "create"].map((campo) => {
          if (["SpecialInstructions", "PickupGoods"].indexOf(campo.id) >= 0) {
            campo.type = "Input";
          }
        });
      } else if (attribute == "CustomerId") {
        selectCatalog["consignees"] = [];
        selectCatalog["suppliers"] = [];
        let limpiarRecoleccion = true;
        let limpiarEntrega = true;
        if (info["FreightTermCode"]) {
          let [recoleccionCode, entregaCode] =
            info["FreightTermCode"].split("2");
          limpiarRecoleccion = recoleccionCode == "D";
          limpiarEntrega = entregaCode == "D";
        }
        info["SpecialInstructions"] = limpiarEntrega
          ? ""
          : info["SpecialInstructions"];
        info["PickupGoods"] = limpiarRecoleccion ? "" : info["PickupGoods"];
      }
    }

    fieldsDependency.forEach((fieldArray) => {
      if (fieldArray.indexOf(attribute) >= 0) {
        let flagRequired = false;
        fieldArray.forEach((field) => {
          if (!flagRequired) {
            flagRequired = info[field] && info[field] != "";
          }
        });

        TemplateForms.map((TemplateForm) => {
          TemplateForm[isEdit ? "edit" : "create"].map((field) => {
            if (fieldArray.indexOf(field.id) >= 0) {
              field.required = flagRequired;
            }
          });
        });
      }
    });

    this.setState({ info, deliverAddressInput, pickupAddressInput }, () => {
      this.renderForm(isEdit);
    });
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index && value != null && value != "";
  };

  handleChangeFilter =
    (campo, isEdit) => (nextTargetKeys, direction, moveKeys) => {
      let { info, guardarDisabled } = this.state;
      if (info[campo]) {
        if (direction === "left") {
          moveKeys.forEach((key) => {
            var removeKey = info[campo].indexOf(key);
            if (removeKey > -1) {
              info[campo].splice(removeKey, 1);
            }
          });
          this.sendMessage(this.props.t("retired"), "info");
        } else {
          moveKeys.forEach((key) => {
            info[campo].push(key);
          });
          this.sendMessage(this.props.t("added"), "info");
        }

        info[campo] = info[campo].filter(this.onlyUnique);
      } else {
        this.sendMessage(this.props.t("added"), "info");
        info[campo] = moveKeys;
      }
      guardarDisabled = true;
      if (
        [1, 2].indexOf(info["RoleId"]) >= 0 ||
        (info[campo] && info[campo].length > 0)
      ) {
        guardarDisabled = false;
      }

      this.setState({ info, guardarDisabled });
    };

  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#0561fc",
      confirmButtonText: "Ok",
      html: `<div class="text-center euro-title-form">
      ${text}
      </div>`,
      customClass: {
        confirmButton: 'custom-width-btn swal'
      }
    });
  };

  editarInformacionAlta = () => {
    this.setState({ showClientes: false, camposUsuario: true }, () => {
      this.renderForm(false);
    });
  };

  parsearArrayInt = (arr) => {
    let intArr = [];
    arr.map((s) => {
      intArr.push(parseInt(s));
    });
    return intArr;
  };

  obtenerTablaClientes = (EntitiesIds) => {
    var arrayEntity = [];

    EntitiesIds.map((entId) => {
      this.state.selectCatalog["Entities"].map((catEnt) => {
        if (entId === catEnt.key) {
          arrayEntity.push(catEnt.data);
        }
      });
    });

    return (
      <Table
        columns={this.state.tableEntityConf}
        data={arrayEntity}
        itemsByPage={5}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
          pagination: true,
          search: true,
        }}
      />
    );
  };
  sortCatalogs = (array, attr) => {
    array.sort((a, b) => {
      return a && a[attr] ? a[attr].localeCompare(b[attr]) : -1;
    });
    return array;
  };

  getCatalogs = async () => {
    let { selectCatalog } = this.state;
    let userId = this.props._user;
    await axios
      .get(
        `${Services.ORDEN_SERV.path}orden/catalogs/${userId}?lang=${this.props.lng}`,
        {}
      )
      .then((response) => {
        selectCatalog["Incoterm"] = this.sortCatalogs(
          response.data.incoterms,
          "text"
        );
        selectCatalog["UOMVolume"] = this.sortCatalogs(
          response.data.volume,
          "text"
        );
        selectCatalog["UOMWeight"] = this.sortCatalogs(
          response.data.weight,
          "text"
        );
        selectCatalog["UOMDimension"] = this.sortCatalogs(
          response.data.dimension,
          "text"
        );
        selectCatalog["UOMQty"] = this.sortCatalogs(response.data.qty, "text");
        selectCatalog["Entities"] = this.sortCatalogs(
          response.data.clientes,
          "text"
        );
        selectCatalog["TransportModes"] = this.sortCatalogs(
          response.data.modoTransporte,
          "text"
        );
        selectCatalog["FreightTerms"] = this.sortCatalogs(
          response.data.tramoContratado,
          "text"
        );
        this.setState(
          {
            selectCatalog,
          },
          () => {
            this.renderForm();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  handleChangeDate = (name, isEdit) => (date, dateString) => {
    let { info, errorPass, confirmPassError, guardarDisabled } = this.state;

    info[name] = date;

    this.setState(
      { info, errorPass, confirmPassError, guardarDisabled },
      () => {
        this.renderForm(isEdit);
        this.validarCampos();
      }
    );
  };

  handleChange = (name, isEdit, type) => (event) => {
    let {
      info,
      errorPass,
      confirmPassError,
      guardarDisabled,
      fieldsDependency,
      TemplateForms,
    } = this.state;
    if (type == "numeric") {
      const re = /^(\d+(\.\d{0,4})?|\.?\d{1,2})$/;

      if (event.target.value === "" || re.test(event.target.value)) {
        info[name] = event.target.value;

        if (info['GrossWeight'] && info['QTYOrdered']) info['TotalWeight'] = info['GrossWeight'] * info['QTYOrdered']
        else info['TotalWeight'] = ""

      } else if (!info[name]) {
        info[name] = "";
      }
    } else {
      info[name] = event.target.value;
    }
    fieldsDependency.forEach((fieldArray) => {
      if (fieldArray.indexOf(name) >= 0) {
        let flagRequired = false;
        fieldArray.forEach((field) => {
          if (!flagRequired) {
            flagRequired = info[field] && info[field] != "";
          }
        });

        TemplateForms.map((TemplateForm) => {
          TemplateForm[isEdit ? "edit" : "create"].map((field) => {
            if (fieldArray.indexOf(field.id) >= 0) {
              field.required = flagRequired;
            }
          });
        });
      }
    });

    this.setState(
      { info, errorPass, confirmPassError, guardarDisabled },
      () => {
        this.renderForm(isEdit);
      }
    );
  };

  validarCampos = (isEdit) => {
    let { info, TemplateForms } = this.state;
    var valido = true;
    TemplateForms.map((TemplateForm) => {
      var campos = TemplateForm[isEdit ? "edit" : "create"];

      campos.map((campo) => {
        if (campo.required) {
          if (!info[campo.id] || info[campo.id] === "") {
            valido = false;
          }
        }
      });
    });

    return valido;
  };

  recieve = (array) => {
    this.setState({
      newSelected: array,
    });
  };

  dataReport = (data, edit) => {
    let dataReport = { data: data, userId: this.props._user };

    this.setState({
      dataReport,
    });
  };

  recieveProps = (object, open) => {
    let { info, deliverAddressInput, pickupAddressInput } = this.state;
    info[object.stateField] = object.id;
    if (!deliverAddressInput && object.stateField == "DeliveryAddress") {
      info["SpecialInstructions"] = object.id;
    }
    if (!pickupAddressInput && object.stateField == "PickupAddress") {
      info["PickupGoods"] = object.id;
    }

    this.setState(
      {
        info,
      },
      () => {
        this.renderForm(false);
      }
    );
  };

  setDateOpen = (flag, id) => {
    let { dateOpen } = this.state;
    dateOpen[id] = flag;
    this.setState({ dateOpen }, () => {
      this.renderForm(false);
    });
  };
  /*
    ####################################GENERACION DE CAMPOS####################################
   */
  renderForm = (isEdit) => {
    let {
      TemplateForms,
      info,
      selectCatalog,
      dateOpen,
      showCatalogModal,
      createFormsData,
    } = this.state;
    createFormsData = [];
    const { classes } = this.props;
    TemplateForms.map((TemplateForm) => {
      createFormsData.push({
        id: TemplateForm.id,
        expanded: true,
        logo: TemplateForm.logo,
        titulo: TemplateForm.titulo,
        form: TemplateForm[isEdit ? "edit" : "create"].map((e) => {
          if (e.type === "Input") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label>
                      {this.props.t(e.label)}{" "}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "3px",
                  }}
                >
                  <TextField
                    // label={e.placeHolder}
                    disabled={e.disabled}
                    variant="standard"
                    type={e.datatype}
                    name={e.id}
                    value={info[e.id]}
                    maxlength={e.maxlength}
                    minlength={e.minlength}
                    InputProps={{
                      classes: {
                        input: "input-euro",
                      },
                    }}
                    onChange={this.handleChange(
                      e.id,
                      isEdit ? true : false,
                      e.validation
                    )}
                    max={e.max}
                  />
                </div>
              </div>
            );
          } else if (e.type === "TextArea") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label>
                      {this.props.t(e.label)}{" "}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextArea
                    required={e.required}
                    onFocus={(e) => {
                      e.target.setAttribute("autocomplete", "none");
                    }}
                    type={e.datatype}
                    placeholder={this.props.t(e.placeHolder)}
                    name={e.id}
                    value={info[e.id]}
                    className='custom-textarea'
                    style={{ width: "100%" }}
                    onChange={this.handleChange(e.id, isEdit ? true : false)}
                  />
                </div>
              </div>
            );
          } else if (e.type === "LabelRef") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label>
                      {this.props.t(e.label)}{" "}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Label>{info[e.id]}</Label>
                </div>
              </div>
            );
          } else if (e.type === "CustomEntidades") {
            return (
              <>
                <div className="col-xs-12 col-md-6 col-lg-6">
                  <Proveedor
                    isEdit={true}
                    CustomerId={info.CustomerId}
                    suppliers={
                      selectCatalog["suppliers"]
                        ? selectCatalog["suppliers"]
                        : []
                    }
                    sendProps={this.recieveProps}
                    errors={this.state.errors}
                  ></Proveedor>
                </div>
                <div className="col-xs-12 col-md-6 col-lg-6">
                  <Consignatario
                    isEdit={true}
                    CustomerId={info.CustomerId}
                    consignees={
                      selectCatalog["consignees"]
                        ? selectCatalog["consignees"]
                        : []
                    }
                    sendProps={this.recieveProps}
                    errors={this.state.errors}
                  ></Consignatario>
                </div>
              </>
            );
          } else if (e.type === "Select") {
            let autocompleteValue = this.findInCatalog(
              info,
              e.id,
              e.selectCatalogName
            );
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  <span id={e.id} style={e.style}>
                    {" "}
                    <label>
                      {this.props.t(e.label)}{" "}
                      {e.required ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}{" "}
                    </label>
                  </span>
                </Fade>
                <Autocomplete
                  disabled={e.disabled}
                  closeText={false}
                  openText={false}
                  style={{ marginTop: "6px" }}
                  id="size-small-standard"
                  className="input-euro"
                  size="small"
                  // freeSolo
                  ListboxProps={{
                    sx: { fontSize: 12 },
                  }}
                  sx={{
                    "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                      fontSize: 12,
                    },
                  }}
                  options={
                    selectCatalog[e.selectCatalogName]
                      ? selectCatalog[e.selectCatalogName]
                      : []
                  }
                  // getOptionLabel={(option) => {
                  //   return <div>
                  //     {option.text}
                  //     {option.subText && option.subText != "" ?
                  //       <label style={{ opacity: ".5" }}>{option.subText}</label> :
                  //       ""
                  //     }

                  //   </div>
                  // }}
                  getOptionLabel={(option) => option.text}
                  renderOption={(props, option, value) => {
                    props.key = option.key;
                    return (
                      <div {...props}>
                        {option.subText && option.subText != "" ? (
                          <div className="row">
                            <div className="col-12">{option.text}</div>

                            <div className="col-12">
                              <label style={{ opacity: ".5" }}>
                                {option.subText}
                              </label>{" "}
                            </div>
                          </div>
                        ) : (
                          <span>{option.text}</span>
                        )}
                      </div>
                    );
                  }}
                  filterOptions={(options, event) => {
                    let filteredOptions = options.filter((opt) => {
                      return (
                        event.inputValue == "" ||
                        opt.text
                          .toLowerCase()
                          .includes(event.inputValue.toLowerCase())
                      );
                    });
                    return filteredOptions;
                  }}
                  onChange={this.handleChangeDrop(e.id, isEdit)}
                  // value={autocompleteValue}
                  popupIcon={e.id == "CustomerId" ? <CustomPopupIcon /> : undefined}
                  // classes={
                  //   e.id == "CustomerId"
                  //     ? {
                  //       clearIndicatorDirty: classes.clearIndicator,
                  //       popupIndicator: classes.popupIndicator,
                  //       popupIndicatorOpen: classes.popupIndicatorOpen,
                  //     }
                  //     : false
                  // }
                  isOptionEqualToValue={(option, value) => {
                    return option.value == value.value;
                  }}
                  value={autocompleteValue}
                  renderInput={(params) => {
                    params.inputProps.value =
                      autocompleteValue && autocompleteValue.text
                        ? autocompleteValue.text
                        : params.inputProps.value;
                    return (
                      <TextField
                        {...params}
                        variant="standard"
                        className={classes.textfield}
                      />
                    );
                  }}
                />

                <Fade left opposite>
                  <label style={e.style}>{e.error}</label>
                </Fade>
              </div>
            );
          } else if (e.type === "Date") {
            let dateId = e.id;
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  <span id={e.id} style={e.style}>
                    {" "}
                    <label>
                      {this.props.t(e.label)}{" "}
                      {e.required ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}{" "}
                    </label>
                  </span>
                </Fade>
                <LocalizationProvider
                  adapterLocale={this.props.lng == "US" ? enLocale : esLocale}
                  dateAdapter={AdapterDateFns}
                >
                  <DatePicker
                    OpenPickerButtonProps={{ style: { display: "none" } }}
                    placeholder={this.props.t(e.label)}
                    open={dateOpen[dateId] == true}
                    onOpen={() => this.setDateOpen(true, dateId)}
                    onClose={() => this.setDateOpen(false, dateId)}
                    id={e.id}
                    inputFormat={e.format}
                    renderInput={(params) => (
                      <TextField
                        className={classes.datefield}
                        onClick={(e) => this.setDateOpen(true, dateId)}
                        variant="standard"
                        {...params}
                      />
                    )}
                    value={info[e.id] ? info[e.id] : null}
                    onChange={this.handleChangeDate(e.id, isEdit)}
                    style={{ marginTop: "3px" }}
                  />
                </LocalizationProvider>
                <Fade left opposite>
                  <label style={e.style}>{e.error}</label>
                </Fade>
              </div>
            );
          } else {
            return (
              <div
                className={e.class}
                style={{ marginTop: "20px" }}
                key={e.id}
              ></div>
            );
          }
        }),
      });
    });
    this.setState({
      createFormsData,
      showCatalogModal,
      info,
      isEdit,
    });
  };

  findInCatalog = (info, id, catalogName) => {
    let { selectCatalog } = this.state;
    let value = {};
    value = selectCatalog[catalogName]
      ? selectCatalog[catalogName].find((catalog) => {
        return info[id] == catalog.value;
      })
      : undefined;
    return value;
  };
  generarInfoGeneral = () => {
    let { info, isEdit, showClientes, TemplateForms } = this.state;

    let generalInfo = TemplateForms.map((TemplateForm) => {
      TemplateForm["previewForm"].map((e) => {
        var attrInfo = "";
        var extraClass = "";

        if (e.type === "label") {
          attrInfo = <span>{info[e.id]}</span>;
        } else if (e.type === "list") {
          // attrInfo = <ul>
          //     {info[e.id].map(element => {
          //         return <li>{element}</li>
          //     })}
          // </ul>
          attrInfo = <span>{info[e.id].length}</span>;
          extraClass = "";
        } else if (e.type === "select") {
          if (info[e.id]) {
            let catalog = this.state.selectCatalog[e.selectCatalogName];

            var value = catalog.filter((cat) => cat.key === info[e.id]);

            attrInfo = <span>{value[0].text}</span>;
          }
        } else if (e.type === "password") {
          if (this.state.isEdit) {
            return;
          }
          attrInfo = <span>***********</span>;
        }
        return (
          <div className={e.class} style={{ paddingTop: "1%" }}>
            {
              <div className="row">
                <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                  <span style={{ fontWeight: "bold" }}>
                    {this.props.t(e.label)}
                  </span>
                </div>
                <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                  {attrInfo}
                </div>
              </div>
            }
          </div>
        );
      });
    });

    if (!isEdit) {
      showClientes = true;
    }
    var guardarDisabled = true;
    if ([1, 2].indexOf(info["RoleId"]) >= 0) {
      guardarDisabled = false;
      showClientes = false;
    } else if (info.Entities && info.Entities.length > 0) {
      guardarDisabled = false;
    }
    this.setState({
      camposUsuario: false,
      showClientes,
      guardarDisabled,
      generalInfo,
    });
  };

  confirmaGuardado = async () => {
    let { info, TemplateForms } = this.state;
    let messageError = "";

    let validation = [];
    let errors = "";
    TemplateForms.map((TemplateForm) => {
      TemplateForm["create"].map((e) => {
        if (e.required === true) {
          validation.push(e);
        }
        return e;
      });
    });
    validation.forEach((e) => {
      if (!info[e.id] || info[e.id] === "") {
        errors += this.props.t(e.label) + ", ";
        document.getElementById(e.id).style.color = "red";
      } else {
        document.getElementById(e.id).style.color = "#000a2e";
      }
    });

    if (errors.length > 0) {
      messageError = this.props.t("please_type_info_required" + ": " + errors);
      if (messageError !== this.state.messageError) {
        this.setState({ messageError: messageError });
        openNotification('error', this.props.t("please_type_info_required") + ": " + errors);
      }
    } else {
      if (!info["DeliveryAddress"] || info["DeliveryAddress"] === "") {
        messageError = "Favor de capturar la dirección de entrega";
        if (messageError !== this.state.messageError) {
          this.setState({ messageError: messageError });
          openNotification('error', "Favor de capturar la dirección de entrega");
        }
      } else if (!info["ConsigneeId"] || info["ConsigneeId"] === "") {
        messageError = "Favor de seleccionar un consignatario";
        if (messageError !== this.state.messageError) {
          this.setState({ messageError: messageError });
          openNotification('error', "Favor de seleccionar un consignatario");
        }
      } else if (!info["SupplierId"] || info["SupplierId"] === "") {
        messageError = "Favor de seleccionar un proveedor";
        if (messageError !== this.state.messageError) {
          this.setState({ messageError: messageError });
          openNotification('error', "Favor de seleccionar un proveedor");
        }
      } else if (!info["PickupAddress"] || info["PickupAddress"] === "") {
        messageError = "Favor de capturar la dirección de recolección";
        if (messageError !== this.state.messageError) {
          this.setState({ messageError: messageError });
          openNotification('error', "Favor de capturar la dirección de recolección");
        }
      } else {
        this.setState({ loadingTmpInfo: true }, () => {
          this.saveOrder();
        });
      }
    }
  };

  limpiarDatos = (info) => {
    let tmpInfo = _.cloneDeep(info);

    if (tmpInfo.data.ActualCargoReadyDate) {
      tmpInfo.data.ActualCargoReadyDate = moment(
        tmpInfo.data.ActualCargoReadyDate
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.ActualCargoReadyDate;
    }
    if (tmpInfo.data.ActualPickupDate) {
      tmpInfo.data.ActualPickupDate = moment(
        tmpInfo.data.ActualPickupDate
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.ActualPickupDate;
    }
    if (tmpInfo.data.EstPickupDate) {
      tmpInfo.data.EstPickupDate = moment(tmpInfo.data.EstPickupDate).format(
        "YYYY-MM-DD"
      );
    } else {
      delete tmpInfo.data.EstPickupDate;
    }
    if (tmpInfo.data.FinalDestinationArrivalDate) {
      tmpInfo.data.FinalDestinationArrivalDate = moment(
        tmpInfo.data.FinalDestinationArrivalDate
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.FinalDestinationArrivalDate;
    }
    if (tmpInfo.data.PromiseCargoReadyDate) {
      tmpInfo.data.PromiseCargoReadyDate = moment(
        tmpInfo.data.PromiseCargoReadyDate
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.PromiseCargoReadyDate;
    }
    if (tmpInfo.data.RequiredDateDestination) {
      tmpInfo.data.RequiredDateDestination = moment(
        tmpInfo.data.RequiredDateDestination
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.RequiredDateDestination;
    }
    if (tmpInfo.data.TransitToFinalDestinationDate) {
      tmpInfo.data.TransitToFinalDestinationDate = moment(
        tmpInfo.data.TransitToFinalDestinationDate
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.TransitToFinalDestinationDate;
    }

    if (tmpInfo.data.EstCargoReadyDate) {
      tmpInfo.data.EstCargoReadyDate = moment(
        tmpInfo.data.EstCargoReadyDate
      ).format("YYYY-MM-DD");
    } else {
      delete tmpInfo.data.EstCargoReadyDate;
    }

    if (!tmpInfo.data.Length || tmpInfo.data.Length == "") {
      delete tmpInfo.data.Length;
    }
    if (!tmpInfo.data.Width || tmpInfo.data.Width == "") {
      delete tmpInfo.data.Width;
    }
    if (!tmpInfo.data.Height || tmpInfo.data.Height == "") {
      delete tmpInfo.data.Height;
    }
    if (!tmpInfo.data.UOMDimensions || tmpInfo.data.UOMDimensions == "") {
      delete tmpInfo.data.UOMDimensions;
    }

    if (!tmpInfo.data.GrossWeight || tmpInfo.data.GrossWeight == "") {
      delete tmpInfo.data.GrossWeight;
    }
    if (!tmpInfo.data.UOMWeight || tmpInfo.data.UOMWeight == "") {
      delete tmpInfo.data.UOMWeight;
    }

    if (
      !tmpInfo.data.SupplierContactId ||
      tmpInfo.data.SupplierContactId == ""
    ) {
      delete tmpInfo.data.SupplierContactId;
    }
    if (
      !tmpInfo.data.ConsigneeContacId ||
      tmpInfo.data.ConsigneeContacId == ""
    ) {
      delete tmpInfo.data.ConsigneeContacId;
    }

    return _.cloneDeep(tmpInfo);
  };

  saveOrder = async () => {
    let { info, selectCatalog } = this.state;

    let data = { data: _.cloneDeep(info) };
    data = this.limpiarDatos(data);
    data.data.UserId = this.props._user;
    data.data.lang = this.props.lng;
    //Debe de estar presente aunque nos e haya agregado
    data.data.CheckPickupAddress =
      !data.data.CheckPickupAddress || data.data.CheckPickupAddress == 0
        ? false
        : true;
    //Debe de estar presente aunque nos e haya agregado
    data.data.CheckDeliveryAddress =
      !data.data.CheckDeliveryAddress || data.data.CheckDeliveryAddress == 0
        ? false
        : true;

    let consignee = selectCatalog["consignees"].find((cons) => {
      return cons.entityCode == data.data.ConsigneeId;
    });
    data.data.ConsigneeAPIInfo = consignee;
    data.data.ConsigneeAPIContactInfo =
      data.data.ConsigneeContacId && data.data.ConsigneeContacId != ""
        ? consignee.contacts.find((cont) => {
          return cont.contactCode == data.data.ConsigneeContacId;
        })
        : {};

    let supplier = selectCatalog["suppliers"].find((cons) => {
      return cons.entityCode == data.data.SupplierId;
    });
    data.data.SupplierAPIInfo = supplier;
    data.data.SupplierAPIContactInfo =
      data.data.SupplierContactId && data.data.SupplierContactId != ""
        ? supplier.contacts.find((cont) => {
          return cont.contactCode == data.data.SupplierContactId;
        })
        : {};

    await axios
      .post(`${Services.ORDEN_SERV.path}orden/createOrder`, data)
      .then((response) => {
        this.setState({ loadingTmpInfo: false })
        this.toggleSuccess()
      })
      .catch((error) => {
        this.setState({ loadingTmpInfo: false, errorMessage: error.response.data.message });
        this.toggle()
      });
  };

  toggle = () => this.setState({ modalError: !this.state.modalError })
  toggleSuccess = () => this.setState({ modalSuccess: !this.state.modalSuccess })


  panelChange = (id) => (evt, expanded) => {
    let { createFormsData } = this.state;
    createFormsData.map((form) => {
      if (form.id == id) {
        form.expanded = expanded;
      }
    });
    this.setState({ createFormsData });
  };

  render() {
    let { loadingInfo, loadingTmpInfo, errorMessage, modalError, modalSuccess } = this.state;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContainerWrapper>
        {loadingTmpInfo ? <Loader /> : false}
        <div className="content-heading">
          <span className="icon-po-visibility icon-header" />
          {this.props.t("request")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/po-visibility")}
              />
            </Icon.Group>
            <span className="label-back" onClick={() => this.props.history.push("/po-visibility")}>
              {this.props.t("back")}
            </span>
          </div>
        </div>
        {this.state.createFormsData
          ? this.state.createFormsData.map((form) => {
            return (
              <Card className="myCard">
                <ExpansionPanel
                  defaultExpanded
                  onChange={this.panelChange(form.id)}
                >
                  <ExpansionPanelSummary
                    onclic
                    expandIcon={
                      form.expanded ? <ExpandLess /> : <ExpandMore />
                    }
                  >
                    {/* <div style={{ display: "inline-flex", alignItems: "center" }}> */}
                    <div style={{ marginRight: "14px" }}></div>
                    <div className="col-12">
                      <h4 className="euro-title-form">
                        {" "}
                        {this.props.t(form.titulo)}
                      </h4>
                    </div>
                    {/* </div> */}
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <CardBody>
                      {/* <div className="col-12"
                  style={{ marginTop: "-2em", marginLeft: "-3px" }}
                > */}
                      {<div className="col-12 row">{form.form}</div>}
                      {/* </div> */}
                    </CardBody>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Card>
            );
          })
          : false}
        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-6">
            <Button
              color="secondary"
              className="custom-width-btn float-right"
              onClick={() => {
                this.props.history.push("/po-visibility");
              }}
            >
              {this.props.t("cancel")}
            </Button>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-6">
            <Button
              color="primary"
              className="custom-width-btn float-left"
              onClick={() => this.confirmaGuardado()}
            >
              {this.props.t("create")}
            </Button>
          </div>
        </div>
        {createModal({
          isModalOpen: modalError,
          type: 'error',
          titleModal: 'Error',
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{errorMessage}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t('Ok'),
              onClick: this.toggle,
              type: "primary",
            }
          ],
          onCancel: this.toggle,
        })}

        {createModal({
          isModalOpen: modalSuccess,
          type: 'success',
          titleModal: 'Success',
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("order_created_successfully")}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t('Ok'),
              onClick: () => { this.props.history.push("/po-visibility") },
              type: "primary",
            }
          ],
          onCancel: () => { this.props.history.push("/po-visibility") },
        })}
      </ContainerWrapper>
    );
  }
}

export default withNamespaces()(
  withRouter(withStyles(useStyles)(createPedido))
);
